"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientSideAnalyticSagas = void 0;
var effects_1 = require("redux-saga/effects");
var Analytics_1 = require("@/api/vendor/Analytics");
var RootSaga_1 = require("@/pages/common/sagas/RootSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var pagenames = ['SEARCH', 'SAVE_SEARCH', 'DEVELOPMENTS', 'ALERT', 'ACCOUNT_INFO', 'CHANGE_PASSWORD', 'LOCATIONS', 'CONTACTS', 'MANAGE_DATA', 'CONFIRM_EMAIL_REGISTER', 'LOCKOUT', 'FORGOT_PASSWORD', 'FORGOT_PASSWORD_RESULT', 'REVERIFY_EMAIL', 'REVERIFY_EMAIL_RESULT', 'CONTACT_AGENT', 'STATIC_CONTENT', 'INVESTOR', 'ABOUT', 'ABOUTUS', 'PRICE_LIST', 'ACCOUNT_LOGIN', 'DEVELOPMENT', 'HOME', 'HOME_ZH', 'BUILDING', 'LIST_PROPERTY', 'AGENT_PROFILE', 'DISTRICT', 'AGENT_LISTING', 'TESTIMONIALS', 'NEWS_AND_INSIGHTS', 'RESOURCES', 'GUIDES', 'IN_THE_PRESS', 'STAMP_DUTY', 'INSIGHTS', 'EXECUTIVE_LISTING', 'NEWS_AND_INSIGHTS_DETAIL', '', '', 'DISCOVERY_BAY_GUIDE', '', '', 'PROPERTY_DETAIL', 'ASK_AN_AGENT_LIST', 'PROPERTY_DETAIL_AMP', 'NEWS_AND_INSIGHTS_DETAIL_AMP', 'NOT_FOUND', 'DETAIL_NOT_FOUND', 'ASK_AN_AGENT', 'SITEMAP', 'ENQUIRY_HISTORY', 'ESTATE', 'PHASE', 'MORTGAGE_REPAYMENT', 'MORTGAGE_AFFORDABLILTY', 'MORTGAGE_REFINANCE', 'MORTGAGE', 'MORTGAGE_AFFORDABLILTY_BY_PAYMENT', 'SAVE_PROPERTIES', 'RECENTLY_VIEWED', 'FAQ', 'UNSUBSCRIBE', 'DETAIL_NOT_FOUND_AMP', 'BLOCK', 'PROPERTY_TRANSACTION', 'EXCLUSIVE'];
var getActionName = function (actionType) {
    return (actionType || '')
        .toLowerCase()
        .replace(/_click(ed)?$/i, '')
        .replace(/_toggle$/i, '')
        .replace(/_+/g, ' ')
        .trim();
};
var watchOnAllClicks = function () {
    var IS_CLIENT_SIDE, action, pageIdx, langCode, pagename, interactionType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                IS_CLIENT_SIDE = true;
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take()];
            case 2:
                action = _a.sent();
                if (action.type.toLowerCase().indexOf('_click') < 0 && action.type.toLowerCase().indexOf('_toggle') < 0)
                    return [3 /*break*/, 1];
                return [4 /*yield*/, effects_1.select(RootSaga_1.getCurrentPage)];
            case 3:
                pageIdx = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 4:
                langCode = _a.sent();
                pagename = '';
                try {
                    pagename = pagenames[pageIdx].toLowerCase();
                }
                catch (e) { }
                interactionType = action.type.toLowerCase().indexOf('_toggle') > -1 ? 'toggle' : 'click';
                Analytics_1.handleExternalProviders({
                    google: {
                        tagManager: {
                            datalayers: [
                                { name: 'event', value: 'okay_click' },
                                { name: 'click_event_name', value: action.type },
                                { name: 'interaction_type', value: interactionType },
                                { name: 'interaction_name', value: getActionName(action.type) },
                                { name: 'button_name', value: getActionName(action.type) },
                                { name: 'page', value: pagename },
                                { name: 'lang', value: langCode || '' },
                            ]
                        }
                    }
                }, IS_CLIENT_SIDE);
                return [3 /*break*/, 1];
            case 5: return [2 /*return*/];
        }
    });
};
var clientSideAnalyticSagas = {
    watchOnAllClicks: watchOnAllClicks,
};
exports.clientSideAnalyticSagas = clientSideAnalyticSagas;
